module.exports = __webpack_public_path__ + "assets/img/image1.0deb80b5.webp";